import { render, staticRenderFns } from "./manage-columns-modal.vue?vue&type=template&id=297807a6&scoped=true"
import script from "./manage-columns-modal.vue?vue&type=script&lang=js"
export * from "./manage-columns-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297807a6",
  null
  
)

export default component.exports